import { createFileRoute } from "@tanstack/react-router";
import AlertsEventsView from "src/components/app/AlertsEventsView/AlertsEventsView";
import PortalPage from "src/components/app/PortalPage/PortalPage";
import DocLink from "src/components/docs/DocLink/DocLink";
import { DeferredLoaderData } from "src/lib/LoaderData";
import { projectLoader } from "src/lib/ScopedLoaders";
import { getAlertsPageData } from "src/server/functions/Portal";
import { useExtracted } from "#i18n";

export const Route = createFileRoute("/_authed/portal/proj_{$projectKey}/alerts")({
  loader: projectLoader((projectId) => getAlertsPageData({ data: projectId })),
  component: AlertsPage,
});

function AlertsPage() {
  const translateMessage = useExtracted();
  return (
    <PortalPage>
      <PortalPage.Header>
        <PortalPage.Heading>
          <PortalPage.Title>{translateMessage("Alerts & Events")}</PortalPage.Title>
          <PortalPage.Description>
            {translateMessage("A chronological record of moderation, asset, and system activity.")}
          </PortalPage.Description>
          <PortalPage.Docs>
            <DocLink topic="notifications" />
            <DocLink topic="events" />
          </PortalPage.Docs>
        </PortalPage.Heading>
      </PortalPage.Header>
      <PortalPage.Content>
        <DeferredLoaderData result={Route.useLoaderData()}>
          {(data) => (
            <AlertsEventsView initialPage={data?.initialPage} initialProjectId={data?.projectId} />
          )}
        </DeferredLoaderData>
      </PortalPage.Content>
    </PortalPage>
  );
}
